// Author YuJiaBei
// Date 2021-08-03 17:24:02

class SithMesPrdPdsrRPrpPdrp {
constructor({
        id = null,
        pdrpIdPdsr = '',
        pdrpIdPrp = '',
        pdrpBeginDate = '',
        pdrpEndDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.pdrpIdPdsr = pdrpIdPdsr;
    this.pdrpIdPrp = pdrpIdPrp;
    this.pdrpBeginDate = pdrpBeginDate;
    this.pdrpEndDate = pdrpEndDate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPdsrRPrpPdrp();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pdrpIdPdsr',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdrpIdPdsr',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pdsrData',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdsrData',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pdsrCreatedTime',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdsrCreatedTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pdsrCreatedBy',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdsrCreatedBy',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pdrpIdPrp',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdrpIdPrp',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pdrpBeginDate',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdrpBeginDate',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'pdrpEndDate',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdrpEndDate',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'pdsrAdjustReason',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.pdsrAdjustReason',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    pdrpIdPdsrFilter : "",
    pdrpIdPrpFilter : "",
    pdrpBeginDateRteFilter : "",
    pdrpBeginDateLteFilter : "",
    pdrpEndDateRteFilter : "",
    pdrpEndDateLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'pdrpIdPdsrFilter',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.filter.pdrpIdPdsr',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pdrpIdPrpFilter',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.filter.pdrpIdPrp',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pdrpBeginDateRteFilter',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.filter.pdrpBeginDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'pdrpBeginDateLteFilter',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.filter.pdrpBeginDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'pdrpEndDateRteFilter',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.filter.pdrpEndDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'pdrpEndDateLteFilter',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.filter.pdrpEndDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'pdrpIdPdsr',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.entity.pdrpIdPdsr',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pdrpIdPrp',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.entity.pdrpIdPrp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pdrpBeginDate',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.entity.pdrpBeginDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'pdrpEndDate',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.entity.pdrpEndDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPdsrRPrpPdrp.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPdsrRPrpPdrp, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
